/** Normalize list/detail status labels (ES display or EN enum). */
export function normalizeInventoryRecordStatus(status: string | null | undefined): string {
  return (status ?? '').toLowerCase();
}

export function isInventoryRecordCompleted(status: string | null | undefined): boolean {
  const s = normalizeInventoryRecordStatus(status);
  return s === 'completado' || s === 'completed';
}

export function isInventoryRecordCancelled(status: string | null | undefined): boolean {
  const s = normalizeInventoryRecordStatus(status);
  return s === 'cancelado' || s === 'cancelled';
}
